<template>
  <div class="page white_bg">

    <div style="height: 46px;">
      <header class="pageHeader detailPageHeader paddingH16 paddingV8 white_bg lightGreyBottomBorder"
        style="line-height: 30px;">
        <div class="borderLayout">
          <div class="middleRegion">
            <div class="westRegion" style="width: 60px">
              <span class="icon leftAngleBracketIcon floatL" style="margin-top: 3px;" @click="back();"></span>
            </div>
            <div class="centerRegion alignCenter font18r primaryTextColor bold" style="height: 30px; overflow: hidden">
              {{title}}
            </div>
            <div class="eastRegion font14r alignRight" style="width: 60px">
              <!--                            <router-link class="primaryTextColor bold" to="">链接</router-link>-->
            </div>
          </div>
        </div>
      </header>
    </div>

    <div class="body">
      <form class="form jobForm font14r generalPagePaddingH" action="javascript:;">

        <div class="form_row">
          <label class="block formLabel">岗位名称</label>
          <div class="marginT12">
            <select class="selectBox" v-model="dataItem.name">
              <option :value="0">请选择岗位</option>
              <option :value="job.name" v-for="(job, i) in jobNameList" :key="i">
                {{ job.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="form_row">
          <label class="block formLabel">薪资待遇</label>
          <div class="marginT12 font14r color333">
            <select class="salarySelect" v-model="dataItem.salaryMin">
              <option :value="0">面议</option>
              <option :value="min" v-for="min in 30" :key="min"
                :disabled="dataItem.salaryMax ? (dataItem.salaryMax <= min ? true : false) : false">{{min}}
              </option>
            </select>
            <span v-if="dataItem.salaryMin  !== 0">&nbsp;-&nbsp;</span>
            <select v-if="dataItem.salaryMin  !== 0" class="salarySelect" v-model="dataItem.salaryMax">
              <option :value="max" v-for="max in 30" :key="max"
                :disabled="dataItem.salaryMin ? (dataItem.salaryMin >= max ? true : false) : false">{{max}}
              </option>
            </select>
            <span v-if="dataItem.salaryMin  !== 0">&nbsp;千/月</span>
          </div>
        </div>
        <div class="form_row">
          <label class="block formLabel">岗位介绍</label>
          <div class="marginT12">
            <textarea class="inputbox noOutline font14r w100p" style="min-height: 80px;" type="text" placeholder="岗位介绍"
              v-model="dataItem.information" />
          </div>
        </div>
        <div class="formRow">

          <label class="block formLabel">意向工作地</label>
          <div class="marginT12" style="display: flex;">

            <select v-model="selectedProvince" class="salarySelect" @change="selectProvinceChange">
              <option value="province">省/直辖市</option>
              <option v-for="(item, i) in citiesList" :value="item" :key="i">
                {{ item.name }}
              </option>
            </select>
            <div style="margin: 0 6px;">—</div>
            <select v-model="selectedCity" class="salarySelect" @change="selectCityChange">
              <option value="city">城市</option>
              <option v-for="(item, i) in selectedProvince ? selectedProvince.childList : []" :value="item" :key="i"
                :disabled="selectedProvince ? false : true">
                {{ item.name }}
              </option>
            </select>
            <div style="margin: 0 6px;">—</div>
            <select v-model="selectedArea" class="salarySelect" @change="selectAreaChange">
              <option value="area">区/镇/县</option>
              <option v-for="(item, i) in selectedCity ? selectedCity.childList : []" :value="item" :key="i"
                :disabled="selectedCity ? false : true">
                {{ item.name }}
              </option>
            </select>
          </div>
        </div>
        <div style="height: 86px;">
          <div class="optArea fixedBottom white_bg" style="height: 86px;">
            <div class="generalPagePaddingH" style="padding-top: 5px;">
              <button class="button block orangeButton" style="border-radius: 20px;
                                height: 42px; line-height: 42px;" :disabled="!dataItem || !dataItem.name"
                @click="save">保存设置</button>
            </div>
          </div>
        </div>
      </form>
    </div>

  </div>
</template>

<script>
// data
import citiesList from '@/data/citiesList_v2'

import shixunPagePart from '@/components/shixunApp/shixunPagePart';

// platformApi
import requestManager from "../platformApi/requestManager.js";

// util
import appHelper                from '@util/appHelper';
import administrativeAreaHelper from '@/util/administrativeAreaHelper';

administrativeAreaHelper.init(citiesList);

const config = {
  apiConfig: {
    add: {
      url: 'portal/recruit/jobs/add',
      method: 'post'
    },
    get: {
      url: '/portal/recruit/jobs/getJobName',
      method: 'get'
    }
  }
};

export default {
  name: "editJob",
  extends: shixunPagePart,
  data () {
    return {
      title: '添加职位',
      apiConfig: config.apiConfig,
      dataItem: {
        id: '',
        name: 0,
        salaryMin: 1,
        salaryMax: 9,
        information: '',
        province: '',
        city: '',
        area: ''
      },
      citiesList: citiesList,
      selectedProvince: 'province',
      selectedCity: 'city',
      selectedArea: 'area',
      jobNameList: []
    }
  },
  methods: {
    back: function () {
      appHelper.redirect('/myPark');
    },
    loadJobNameList () {
      requestManager.request(this.apiConfig.get, (error, result) => {
        if (error) {
          return;
        }
        if (result.errorCode) {
          appHelper.showMessage(result.msg);
          return;
        }
        this.jobNameList = result.data;
      });
    },
    onSubmitSuccess () {
      appHelper.showHint('保存成功！');
      appHelper.redirect('/myPark');
    },
    selectProvinceChange (e) {
      this.selectedCity = 'city';
      this.selectedArea = 'area';
      this.dataItem.province = this.selectedProvince.name;
    },
    selectCityChange (e) {
      this.selectedArea = 'area';
      this.dataItem.city = this.selectedCity.name;
    },
    selectAreaChange (e) {
      this.dataItem.area = this.selectedArea.name;
    }
  },
  mounted () {
    this.loadJobNameList();
  }
}
</script>

<style lang="scss" scoped>
.jobForm {
  .form_row {
    padding: 20px 0 10px;
    border-bottom: 1px solid #f0f0f0;
  }
  .formLabel {
    color: #8994a9;
    margin-bottom: 12px;
  }
  .inputbox {
    border: none;
    background: transparent;
    color: #333333;
    font-size: 100%;
    padding: 0;
  }
  .salarySelect {
    width: 78px;
    height: 24px;
    background: #f2f2f2;
    border: 1px solid #f0f0f0;

    border-radius: 2px;
    appearance: none; /* 去掉默认图标 */
    // padding: 0 10px;
    text-align: center;
    text-align-last: center;
  }
}

.selectBox {
  width: 100%;
  background: transparent;
  border: none;
  color: hsla(0, 0%, 20%, 1);
}
</style>
